import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_storage_logsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { notes?: string, level?: number, process?: string, transaction_id?: string, ingress_id?: string, egress_id?: string, created_on?: string, integration_name?: string, $top?: number, $skip?: number }): Promise<{ result?: { id?: string, level?: number, process?: string, transaction_id?: string, ingress_id?: string, egress_id?: string, notes?: string, created_by?: string, created_on?: string, alerted_on?: string, integration_name?: string, message?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { notes?: string, level?: number, process?: string, transaction_id?: string, ingress_id?: string, egress_id?: string, created_on?: string, integration_name?: string, $keys: string[] }): Promise<{ result?: { id?: string, level?: number, process?: string, transaction_id?: string, ingress_id?: string, egress_id?: string, notes?: string, created_by?: string, created_on?: string, alerted_on?: string, integration_name?: string, message?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      notes?: string, level?: number, process?: string, transaction_id?: string, ingress_id?: string, egress_id?: string, created_on?: string, integration_name?: string    }) {
      return false;
    }
}
